// extracted by mini-css-extract-plugin
export default {"quantity-picker":"dmwgTc","quantityPicker":"dmwgTc","button":"N_bfBF","counter":"HOeXWV","disabled":"dTpgMp"};